export default "__VITE_ASSET__149964df__"